import { Pipe } from '@angular/core';
import { applyPrecision } from '../helpers/helpers';
var RoundPipe = (function () {
    function RoundPipe() {
    }
    RoundPipe.prototype.transform = function (num, precision) {
        if (precision === void 0) { precision = 0; }
        return applyPrecision(num, precision);
    };
    RoundPipe.decorators = [
        { type: Pipe, args: [{ name: 'round' },] },
    ];
    /** @nocollapse */
    RoundPipe.ctorParameters = function () { return []; };
    return RoundPipe;
}());
export { RoundPipe };
//# sourceMappingURL=round.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/math/round.js
// module id = 265
// module chunks = 4